const invertedMessages = {
  Close: 'CloseLabel',
};

export default invertedMessages;
